import { z } from 'zod'
import type LargeCardWithGridSection from '../LargeCardWithGridSection.vue'
import type HalfPageAdWithGridSection from '../HalfPageAdWithGridSection.vue'
import type ContentNewsMixSection from '../ContentNewsMixSection.vue'
import type CarouselWithGridSection from '../CarouselWithGridSection.vue'
import type GamesSection from '../GamesSection.vue'
import type CategoryMixSection from '../CategoryMixSection.vue'
import type ContentNewsMixWithKeywordSection from '../ContentNewsMixWithKeywordSection.vue'
import type FiveColumn2x2Card from '../FiveColumn2x2Card.vue'
import type FiveColumn2x2CardCentered from '../FiveColumn2x2CardCentered.vue'

/**
 * Standard emit events for test section components.
 * All test sections must emit these events for proper coordination with the parent (Home.vue):
 * - `used-articles`: Number of articles consumed by this section (for feed deduplication)
 * - `loading`: Loading state changes (for page view tracking coordination)
 */
export type TestSectionEmits = {
  'used-articles': [count: number]
  loading: [isLoading: boolean]
}

const adBaseSchema = z.object({
  y: z.number(),
  x: z.number(),
  classes: z.string(),
})

export const aboveFoldSectionAdsSchema = z.object({
  billboardAdClasses: z.object({
    widgetId: z.string().optional(),
    classes: z.string().optional(),
  }),
  billboardAdSize: z.optional(
    z.union([z.literal('small'), z.literal('medium'), z.literal('large')])
  ),
  grid3: z.array(adBaseSchema),
  grid2: z.array(adBaseSchema),
  grid1: z.array(adBaseSchema),
})

export type SectionComponents = {
  LargeCardWithGridSection: typeof LargeCardWithGridSection
  HalfPageAdWithGridSection: typeof HalfPageAdWithGridSection
  ContentNewsMixSection: typeof ContentNewsMixSection
  ContentNewsMixWithKeywordSection: typeof ContentNewsMixWithKeywordSection
  CarouselWithGridSection: typeof CarouselWithGridSection
  GamesSection: typeof GamesSection
  CategoryMixSection: typeof CategoryMixSection
  FiveColumn2x2Card: typeof FiveColumn2x2Card
  FiveColumn2x2CardCentered: typeof FiveColumn2x2CardCentered
}

export type AdBase = z.infer<typeof adBaseSchema>
export type AboveFoldSectionAds = z.infer<typeof aboveFoldSectionAdsSchema>
